export default __webpack_public_path__ + "images/docs-upload-mobile.png";